import qs from 'querystring';
import {
	first, find, filter, includes,
} from 'lodash';
import { createSelector } from 'reselect';
import { selectors } from 'zender-api-client';
import uiTheming from '../ui/theming';

export const queryParamsSelector = () => qs.parse(window.document.location.search.substring(1));

export const interactionsSelector = createSelector(
	state => state.ui.interactions,
	interactions => interactions
);

export const doneQuestionIdsSelector = createSelector(
	state => (state.ui.data.quiz || {}).doneQuestionIds,
	doneQuestionIds => doneQuestionIds
);

export const latestActiveQuestionSelector = createSelector(
	selectors.quiz.latestQuizQuestionsSelector,
	doneQuestionIdsSelector,
	(questions, doneQuestionIds) => first(filter(questions, q => !includes(doneQuestionIds, q.id)))
);

export const latestDoneQuestionSelector = createSelector(
	selectors.quiz.latestQuizQuestionsSelector,
	doneQuestionIdsSelector,
	(questions, doneQuestionIds) => find(questions, q => includes(doneQuestionIds, q.id))
);

export const themingSelector = createSelector(
	selectors.target.targetThemingSelector,
	selectors.config.configThemingSelector,
	(targetTheming, configTheming) => {
		// config theming has precedence over target theming
		/* eslint-disable no-param-reassign */
		const reduceTheming = (obj, key, theming, defaultTheming) => {
			const type = typeof theming[key];
			switch (type) {
				case 'object':
					obj[key] = Array.isArray(theming[key]) ?
						theming[key] :
						{ ...defaultTheming[key], ...theming[key] };
					break;
				case 'undefined':
					obj[key] = defaultTheming[key];
					break;
				default:
					obj[key] = theming[key];
					break;
			}
			return obj;
		};
		if (configTheming) {
			const mergedTheming = Object.keys(uiTheming).reduce((previous, current) => reduceTheming(previous, current, configTheming, uiTheming), {});
			return mergedTheming;
		}
		if (targetTheming) {
			const mergedTheming = Object.keys(uiTheming).reduce((previous, current) => reduceTheming(previous, current, targetTheming, uiTheming), {});
			return mergedTheming;
		}
		/* eslint-enable no-param-reassign */
		return uiTheming;
	}
);



// WEBPACK FOOTER //
// ./src/selectors/ui.js